export default function animateRequisitesCard () {
  const buttons = document.querySelectorAll('.requisites-table__mobile-card .cross'),
    cards = document.querySelectorAll('.requisites-table__mobile-card')

  buttons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()

      if(el.parentElement.classList.contains('requisites-table__mobile-card_opened')) {
        el.parentElement.classList.remove('requisites-table__mobile-card_opened')
      } else {
        cards.forEach(el => {
          el.classList.remove('requisites-table__mobile-card_opened')
        })

        el.parentElement.classList.toggle('requisites-table__mobile-card_opened')
      }
    })
  })
}